import { Box, Chip } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { serviceTypesList } from "../../../GoService/enum/service.enum";

const typesList = ["all", ...serviceTypesList];

const AllServicesTypes = ({ isDataLoading }: { isDataLoading: boolean }) => {
  const { t } = useTranslation("profiles", {
    keyPrefix: "allServices",
  });
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const currentType = searchParams.get("type") ?? "all";

  const handleOnChangeType = (type: string) => {
    const searchParams = new URLSearchParams(location.search);
    if (type === "all") {
      searchParams.delete("type");
    } else {
      searchParams.set("type", type);
    }

    navigate({ search: searchParams.toString() });
  };

  const IS_CURRENT_TYPE = (type: string) => currentType === type;

  return (
    <Box
      sx={{
        display: "flex",
        gap: "8px",
      }}
    >
      {typesList.map((type) => (
        <Chip
          key={type}
          label={t(type.toLowerCase())}
          component="button"
          variant="outlined"
          clickable
          onClick={() => handleOnChangeType(type)}
          disabled={isDataLoading}
          sx={{
            padding: "1px 4px",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "20px",
            color: IS_CURRENT_TYPE(type) ? "var(--Green---100, #008B07)" : "var(--Dark---600, #707070)",
            border: IS_CURRENT_TYPE(type) ? "1px solid var(--Brand-600, #008B07)" : "none",
            background: IS_CURRENT_TYPE(type) ? "var(--Brand-25, #F6FFF5)" : "transparent",
          }}
        />
      ))}
    </Box>
  );
};

export default AllServicesTypes;
